export default __webpack_public_path__ + "static/media/August2012.6992afff.png";